import type { IUpsertBranchClientExclusionParams } from 'core/model/interfaces/distributors/branches.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import type { IDistributorsState } from '../../types';

export const upsertBranchCustomersExclusion = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/upsertBranchCustomersExclusion`,
  async (params: IUpsertBranchClientExclusionParams) => {
    try {
      const response = await apiService.branches.upsertBranchCustomersExclusion(params);

      notificationService.global.success('Se ha cargado la exclusión de clientes correctamente.');

      return response;
    } catch (error) {
      notificationService.drawer.error('Error al cargar el archivo. Por favor Inténtalo de nuevo.');

      throw error;
    }
  },
);

export const upsertBranchCustomerExclusionReducer: TSliceExtraReducer<IDistributorsState> = builder =>
  builder
    .addCase(upsertBranchCustomersExclusion.pending, state => {
      state.branchesList.form.loading = true;
      state.branchesList.form.success = false;
      state.branchesList.form.errors = {};
    })
    .addCase(upsertBranchCustomersExclusion.rejected, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = false;
    })
    .addCase(upsertBranchCustomersExclusion.fulfilled, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = true;
      state.branchesList.form.errors = {};
    });
